import { createSelector } from '@ngrx/store';
import { getWizzardSimpleItem } from '../getWizzardSimpleItem';
import { isWizzardLimitReachedForIngredientsGroup } from '../isWizzardLimitReachedForIngredientsGroup';
import { isWizzardIngredientSelected } from '../isWizzardIngredientSelected';

function handleDefaultIngredientMode(isIngredientSelected: boolean): OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE {
    return isIngredientSelected ? OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.REMOVE_INGREDIENT : OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.RESTORE_INGREDIENT;
}

function handleOptionalIngredientMode(isLimitReached: boolean, isIngredientSelected: boolean, canAddOnlyOne: boolean): OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE {
    if (canAddOnlyOne) {
        if (isLimitReached && isIngredientSelected) {
            return OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.REMOVE_OPTIONAL;
        }
        if (isLimitReached && !isIngredientSelected) {
            return OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.REPLACE_OPTIONAL;
        }

        return OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.ADD_OPTIONAL;
    } else {
        if (!isLimitReached && !isIngredientSelected) {
            return OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.ADD_OPTIONAL;
        }

        return null;
    }
}

function handleForSwapsOnlyMode(isIngredientSelected: boolean): OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE {
    return isIngredientSelected ? OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.REMOVE_INGREDIENT : OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.RESTORE_INGREDIENT;
}

function handleObligatoryIngredientMode(isIngredientSelected: boolean): OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE {
    return isIngredientSelected ? OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.NONE : OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.RESTORE_INGREDIENT;
}

export const wizzardIngredientActionToTake = (ingredient: APICommon.ProductIngredientExtended, swap?: APICommon.IngredientProductSwapExtended) =>
    createSelector(
        getWizzardSimpleItem,
        isWizzardLimitReachedForIngredientsGroup(ingredient),
        isWizzardIngredientSelected(swap ? swap.NewPLU : ingredient.IngredientPLU),
        (simpleItem, isLimitReached, isIngredientSelected) => {
            if (!simpleItem || ingredient.ExclusionState !== OLO.Enums.INGREDIENT_EXCLUSION_STATE.AVAILABLE) return null;

            if (swap) {
                if (isIngredientSelected) {
                    return ingredient.IngredientMode === OLO.Enums.INGREDIENT_MODE.OBLIGATORY
                        ? OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.NONE
                        : OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.REMOVE_SWAP;
                }

                return OLO.Enums.WIZZARD_INGREDIENT_ACTION_TO_TAKE.ADD_SWAP;
            }

            const canAddOnlyOne = [1, null].includes(ingredient.IngredientDisplayGroupMaxCount);

            switch (ingredient.IngredientMode) {
                case 0:
                    return handleDefaultIngredientMode(isIngredientSelected);
                case 1:
                    return handleOptionalIngredientMode(isLimitReached, isIngredientSelected, canAddOnlyOne);
                case 2:
                    return handleForSwapsOnlyMode(isIngredientSelected);
                case 3:
                    return handleObligatoryIngredientMode(isIngredientSelected);
                default:
                    return null;
            }
        },
    );
